import {
  Body2,
  Box,
  Button,
  ButtonColorVariant,
  ButtonSize,
  Color,
  Display,
  FlexDirection,
  Heading2,
} from '@gousto-internal/citrus-react'
import type {
  DashboardExperienceActionResponse,
  DashboardExperienceRafCampaignResponse,
  DashboardExperienceRafStatusResponse,
} from '@library/api-dashboard-experience'
import React from 'react'

import { RafActionCard } from './RafActionCard'
import { RafCampaignTiers } from './RafCampaignTiers'
import { RafStatusMetrics } from './RafStatusMetrics'

type RafCampaignActionProps = {
  campaign: DashboardExperienceRafCampaignResponse
  onActionClick?: (actionType: DashboardExperienceActionResponse['type']) => void
}

type RafStatusActionProps = {
  status: DashboardExperienceRafStatusResponse
  onActionClick?: (actionType: DashboardExperienceActionResponse['type']) => void
}

export function RafCampaignAction({ campaign, onActionClick }: RafCampaignActionProps) {
  const handleClick = () => {
    onActionClick?.('raf')
  }

  return (
    <RafActionCard imageTestId="raf-campaign-image" testId="raf-campaign-action">
      <Box display={Display.Flex} flexDirection={FlexDirection.Column} gap={2}>
        <Heading2 color={Color.ColdGrey_800} size={[3, 5]}>
          {campaign.title}
        </Heading2>
        <Body2 color={Color.ColdGrey_800}>{campaign.subtitle}</Body2>
      </Box>

      <RafCampaignTiers tiers={campaign.tiers} />

      <Button
        beforeIcon="share"
        colorVariant={ButtonColorVariant.Secondary}
        data-action-type="raf"
        onClick={handleClick}
        size={ButtonSize.Medium}
        type="button"
        width="100%"
      >
        {campaign.send_cta}
      </Button>
    </RafActionCard>
  )
}

export function RafStatusAction({ status, onActionClick }: RafStatusActionProps) {
  const handleClick = () => {
    onActionClick?.('raf')
  }

  return (
    <RafActionCard imageTestId="raf-status-image" testId="raf-status-action">
      <Box display={Display.Flex} flexDirection={FlexDirection.Column} gap={2}>
        <Heading2 color={Color.ColdGrey_800} size={[3, 5]}>
          {status.title}
        </Heading2>
        <Body2 color={Color.ColdGrey_800}>{status.subtitle}</Body2>
      </Box>

      <RafStatusMetrics status={status} />

      <Button
        beforeIcon="share"
        colorVariant={ButtonColorVariant.Secondary}
        data-action-type="raf"
        onClick={handleClick}
        size={ButtonSize.Medium}
        type="button"
        width="100%"
      >
        {status.invite_cta}
      </Button>
    </RafActionCard>
  )
}
